import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, onMounted } from "vue";
import { useStore } from 'vuex'
import { getToken } from '../http/index'
import { getTokenvue2login ,initialSession} from '../http/vue2login'
import { ElMessage,TabsPaneContext  } from 'element-plus'
// import { oriVaildImages, guid, FormatToken } from '../global/index'
import { oriVaildImages, guid } from '../global/index'
import Tool from '../global/globaltool'  
import {setRSAE, setRSAN} from '../global/auth'
import {UserInfo} from '../../class/Userinfo'
//import {pidCryptUtil,pidCrypt } from '*/pidcrypt.js'

// import pidCryptUtil from '../../node_modules/pidcrypt_util'
//import pidCryptUtil from './a.js';
import 'pidcrypt'
// import 'pidcrypt_util'
  //import pidCrypt from 'pidcrypt'
 // import 'pidCryptUtil'
// //import pidcrypt = require("./pidcrypt")
// var pidCrypt = require("./pidcrypt");

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginCom',
  setup(__props) {

const activeName = ref('first');
var pidCrypt = require("pidcrypt");
require("pidcrypt/aes_cbc");
  require("pidcrypt/rsa");
  
 var pidCryptUtil= require("pidcrypt/pidcrypt_util");
// var pidCryptUtil = require('./pidcrypt_util.js');

//const pidCryptUtilref=ref('pidCryptUtil');
// const pidCryptUtil= require("pidcrypt_util"); 


// const pidCryptUtil = {} as pidCryptUtil
// var pidCrypt = require("pidCrypt")
// require("pidcrypt/aes_cbc")
 
// function pidCryptUtil(name: string, age:number = 32):string {
//   if (typeof age === 'number') {
//     return `我叫${name},今年${age}岁。`
//   } else {
//     return `我加${name}`
//   }
// }

//  var pidCrypt = require("pidCrypt");

//  var pidCryptUtil = require("pidCrypt/pidCryptUtil");
   
//  require("pidcrypt/rsa")
 //require("pidcrypt/pidCryptUtil");
// require("pidcrypt/rsa")
const vaildImages = ref(oriVaildImages.value);
const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event)
}
console.log(vaildImages);

let ValidateKey = "";
//组件加载事件
onMounted(() => {
  
  const t = guid();
  ValidateKey = t;
  vaildImages.value = oriVaildImages.value + t;
});
//点击切换验证码事件
const ChangeImage = () => {
  const t = guid();
  ValidateKey = t;
  vaildImages.value = oriVaildImages.value + t;
}
//vuex
const store = useStore()
const IsShowLogin = computed(() => store.state.IsShowLogin)
const handleClose = (done: () => void) => {
  store.commit('CloseLogin')
  done();
};
const CloseLogin = () => {
  store.commit('CloseLogin')
}
const form = ref();
form.value = {
  UserName: "音娱",
  Password: "123456",
  ValidateCode: "",
  userName:"yy001",
  pwd:"www.520mus.top"


}
const Submit2 = async () => {
  var timestamp = new Date().getTime();
  var data = {
    
    ValidateKey: ValidateKey,
    ValidateCode: form.value.ValidateCode,
          isAutoLogin: true,
          userName: form.value.userName,
          pwd:form.value.pwd,
          enterpwd: '',
          npwd:'',
          code: ''
  } 

  if (data.pwd.length == 0) {
    ElMessage.error("密码长度错误")  
  }
  console.log("001")
  //let user = JSON.parse(FormatToken(res.result as string))
  var r = (await initialSession(timestamp))  ;
  console.log("002")
  if (r.status != 200) {
      ElMessage.error("获取RSA错误")  
   }
          var d = r.data.Data;
          var str_e = d.e;
          var str_n = d.n; 
          var rsa = new pidCrypt.RSA(); 
          // console.log(111 +str_e+ "$$$$$$$$$$$$$$"+str_n) 
          // console.log(3333 +pidCrypt+888888+  +pidCryptUtil) 
          var n = pidCryptUtil?.convertToHex(pidCryptUtil?.decodeBase64(str_n)); 
          var e = pidCryptUtil?.convertToHex(pidCryptUtil?.decodeBase64(str_e)); 
          localStorage["SET_RSAE"]=e 
          localStorage["SET_RSAN"]=n
          setRSAE(e)
          setRSAN(n)   
          rsa.setPublic(n, e, 16);
          var crypted = rsa.encrypt(data.pwd);
          var entryPwd = pidCryptUtil.encodeBase64(pidCryptUtil.convertFromHex(crypted));
          data.npwd = entryPwd; 
          console.log('原来：'+data.pwd+'现在'+   entryPwd+'编码'+encodeURIComponent(entryPwd))       
  const res = (await getTokenvue2login(data.userName, entryPwd,data.code, timestamp,data.isAutoLogin)) as any ;
  console.log(res.data.Status)
  if (res.data.Msg=='登陆成功') {
    ElMessage({
      message: '登录成功！',
      type: 'success',
    })
    //console.log(res.data.Data.token) 
    let tokenlet=res?.data?.Data?.token;
    console.log("tokenlet:"+tokenlet)  
    let user = {
      userCode:res?.data?.Data?.userCode,
      nickName:res?.data?.Data?.userName,
      url: res?.data?.Data?.url,
      token: res?.data?.Data?.token
    } 
    console.log(user)
    localStorage["token"] = res?.data?.Data?.token ;//res.result;
    //设置全局变量的值
    store.commit('SettingNickName', user.nickName) 
    store.commit('userCode', user.userCode)
    //设置localStorage，保证页面刷新后vuex的值可以从里面读，避免刷新后状态丢失
    localStorage["NickName"] = user.nickName
    localStorage["userCode"] = user.userCode
    //登录成功后隐藏登录框
    store.commit('CloseLogin')
  } else {
    ElMessage.error(res.msg)
  }
}

const Submit = async () => {
 
  var data = {
    UserName: form.value.UserName,//use code
    Password: form.value.Password,
    ValidateKey:  ValidateKey,
    ValidateCode: form.value.ValidateCode,
    
  }
  //var res = (await getToken(data)).data; 
  const res = (await getToken(data)).data as any ;
 
  if (res.isSuccess) {
    ElMessage({
      message: '登录成功！',
      type: 'success',
    })
    console.log(res.result)
    // debugger;
    //         const token = await miniapiGetTokenApiResultstr(form.userName, form.passWord,'vue3admin') as any 
    //         debugger;

    let tokenlet=res?.result;
    console.log("tokenlet:"+tokenlet)
    //let user = JSON.parse(FormatToken(res.result as string))
    const user: UserInfo = JSON.parse(new Tool().FormatToken(tokenlet))
    console.log(user)
    localStorage["token"] = res.result;
    //设置全局变量的值
    store.commit('SettingNickName', user.NickName)
    //设置localStorage，保证页面刷新后vuex的值可以从里面读，避免刷新后状态丢失
    localStorage["NickName"] = user.NickName
    //登录成功后隐藏登录框
    store.commit('CloseLogin')
  } else {
    ElMessage.error(res.msg)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(IsShowLogin),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(IsShowLogin) ? (IsShowLogin).value = $event : null)),
    title: "登录",
    width: "30%",
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((activeName).value = $event)),
            class: "demo-tabs",
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "鲜花520mus登录",
                name: "first"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("鲜花520mus登录 "),
                  _createVNode(_component_el_form_item, { label: "用户名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.UserName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.UserName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "密码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.Password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.Password) = $event)),
                        type: "password",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "验证码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.ValidateCode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.ValidateCode) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_image, {
                        style: {"width":"200px","height":"100px"},
                        src: vaildImages.value,
                        onClick: ChangeImage
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: Submit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("确定")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: CloseLogin }, {
                    default: _withCtx(() => [
                      _createTextVNode("取消")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_tab_pane, {
                label: "音娱云台登录",
                name: "second"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("音娱云台登录 "),
                  _createVNode(_component_el_form_item, { label: "云台用户名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.userName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.userName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "云台密码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.pwd,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.pwd) = $event)),
                        type: "password",
                        "show-password": ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: Submit2
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("云端登录")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, { onClick: CloseLogin }, {
                        default: _withCtx(() => [
                          _createTextVNode("取消")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})